import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex text-gray-800" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  style: {"width":"437px"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mb-3 mt-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "p-error" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "w-10 pl-3" }

import { ref, computed, onBeforeMount, watch } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { useToast } from 'primevue/usetoast';
import { PeopleService } from '@/services';
import { useRouting } from '@/composables';
import { useArchiveStore, usePeopleStore, usePeopleTypesStore } from '@/store';
import { usePersonTypes } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArchiveModal',
  emits: ['onArchived'],
  setup(__props, { emit: __emit }) {

const archiveStore = useArchiveStore();
const peopleStore = usePeopleStore();
const $routing = useRouting();
const toast = useToast();
const reasons = ref();
const reasonId = ref();
const archiveInfo = ref();
const confirmArchiveOpen = ref(false);
const loading = ref(false);
const PEOPLE_TYPES = usePeopleTypesStore().PEOPLE_TYPES;

const emit = __emit;

const rules = computed(() => ({
  reasonId: { required: helpers.withMessage('Please choose a reason', required) },
}));

const v$ = useVuelidate(rules, { reasonId });

const isStudent = computed(() => usePersonTypes.isStudent(archiveStore.person.people_type?.acronym as string));

const needGetInfo = computed(() =>
  usePersonTypes.isType(archiveStore.person.people_type?.acronym as string, [
    PEOPLE_TYPES.STUDENT,
    PEOPLE_TYPES.CLINICIAN,
    PEOPLE_TYPES.PARENT,
    PEOPLE_TYPES.FACILITATOR,
    PEOPLE_TYPES.SCHOOL_ADMIN,
  ]),
);

const formIncomplete = computed(() => isStudent.value && !reasonId.value);

const canArchive = computed(() => !!archiveStore.person.archived_at === false);

onBeforeMount(() => init());

const init = () => {
  loading.value = false;
  confirmArchiveOpen.value = false;
  reasonId.value = false;
  archiveStore.isShow = false;
};

const onCancelArchive = () => init();

watch(archiveStore, (value) => {
  if (value.isShow) openConfirmArchive();
});

const openConfirmArchive = async () => {
  loading.value = true;
  confirmArchiveOpen.value = true;

  if (needGetInfo.value) {
    await PeopleService.getArchiveInfo(archiveStore.person.id).then((response) => {
      archiveInfo.value = response.data.data?.messages;
      reasons.value = response.data.data?.reasons;
    });
  }

  loading.value = false;
};

const onArchive = async () => {
  const payload = reasonId.value ? { archived_reason_id: reasonId.value } : {};
  await PeopleService.archive(archiveStore.person.id, payload)
    .then((response) => doSuccess(response.data.message))
    .catch((error) => doFail(error.data.message));
  confirmArchiveOpen.value = false;
  await peopleStore.getPeople($routing.route.query);
  await peopleStore.getTotals();
  archiveStore.isShow = false;
};

const formatMessage = (message: string, value: string) => {
  return message.replace(':value', `<b>${value}</b>`);
};

const doSuccess = (detail: string) => {
  toast.add({
    severity: 'success',
    summary: 'Archived',
    detail: detail,
    life: 3000,
  });
  emit('onArchived');
};

const doFail = (detail: string) => {
  toast.add({
    severity: 'error',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (canArchive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (confirmArchiveOpen.value)
          ? (_openBlock(), _createBlock(_component_ConfirmAction, {
              key: 0,
              header: "Archive User",
              "accept-label": "Archive User",
              "disable-accept": formIncomplete.value,
              onAccept: onArchive,
              onCancel: onCancelArchive
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_Icon, {
                    name: "warning",
                    class: "confirm-dialog-icon text-gray-600"
                  }),
                  (needGetInfo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "w-10 pl-3" }, "This action will:", -1)),
                        (loading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                                return _createVNode(_component_Skeleton, {
                                  key: n,
                                  width: "100%",
                                  height: "24px",
                                  class: "mb-2"
                                })
                              }), 64))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("ol", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(archiveInfo.value, (info, key) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: key,
                                      class: "mb-1"
                                    }, [
                                      _createElementVNode("span", {
                                        innerHTML: formatMessage(info.message, info.value)
                                      }, null, 8, _hoisted_7)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              (isStudent.value)
                                ? (_openBlock(), _createBlock(_component_Dropdown, {
                                    key: 0,
                                    id: "reason_id",
                                    modelValue: _unref(v$).reasonId.$model,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).reasonId.$model) = $event)),
                                    class: "w-full",
                                    options: reasons.value,
                                    "option-label": "reason",
                                    "option-value": "id",
                                    placeholder: "Select a reason",
                                    onBlur: _unref(v$).reasonId.$touch
                                  }, null, 8, ["modelValue", "options", "onBlur"]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).reasonId.$errors, (error) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: error.$uid,
                                  class: "input-errors"
                                }, [
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(error.$message), 1)
                                ]))
                              }), 128))
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(`Are you sure you want to Archive ${_unref(archiveStore).person.display_name}?`), 1)
                      ]))
                ])
              ]),
              _: 1
            }, 8, ["disable-accept"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})